import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock, Flower2, Bug,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

// Además de los iconos del contrato, esta plantilla suma "flor" y "mariposa".
const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
  flor: Flower2,
  mariposa: Bug,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="km-seccion" aria-label={seccion.titulo}>
      <div className="km-seccion-interior">
        <EncabezadoSeccion p="km" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="km-titulo-itinerario" />
        <Reveal>
          <ul className="km-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="km-itinerario-item" key={i} data-testid={`km-itinerario-item-${i}`}>
                  <span className={`km-itinerario-icono km-itinerario-icono--${(i % 3) + 1}`}>
                    <Icono strokeWidth={2} />
                  </span>
                  <div>
                    <p className="km-itinerario-hora">{item.hora}</p>
                    <h3 className="km-itinerario-titulo">{item.titulo}</h3>
                    {item.descripcion && <p className="km-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
